export default function WorkGallery2() {
  return (
    <section className="py-10">
      <div className="sm:w-11/12 mx-auto px-4 sm:px-0 flex flex-col gap-4">

        {/* Row 1 */}

                    <div className="rounded-3xl overflow-hidden aspect-square">

            <img
              src="/crunchies4.jpg"
              alt="Mobile banking"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/crunchies1.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/crunchies2.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>
  

        {/* Row 2 */}

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/crunchies3.jpg"
              alt="Mobile banking"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/crunchies4.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

                    <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/crunchies17.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/crunchies5.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>
  

        {/* Row 3 */}
          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/crunchies6.jpg"
              alt="Mobile banking"
              className="w-full h-full object-cover block"
            />
          </div>

<div className="hidden sm:block rounded-3xl overflow-hidden">
  <img
    src="/crunchies7.jpg"
    alt="Petrol station"
    className="w-full h-full object-cover block"
  />
</div>

<div className="hidden sm:block rounded-3xl overflow-hidden">
  <img
    src="/crunchies8.jpg"
    alt="Petrol station"
    className="w-full h-full object-cover block"
  />
</div>


        {/* Row 4 */}
       
          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/crunchies9.jpg"
              alt="Mobile banking"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/crunchies10.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/crunchies16.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/crunchies11.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/crunchies12.jpg"
              alt="Chase campaign"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/crunchies14.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/crunchies13.jpg"
              alt="Chase campaign"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/crunchies14.jpg"
              alt="Chase campaign"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/crunchies15.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>

          




      </div>
    </section>
  );
}